/**
 * Labstep
 *
 * @module
 * @desc Edit action for protocol timer
 */

import { EntityActionEdit } from 'labstep-web/components/Entity/Action/Edit';
import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ProtocolTimerFormEdit as EditTimerForm } from 'labstep-web/components/ProtocolTimer/Form/Edit';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { ProtocolTimer } from 'labstep-web/models/protocol-timer.model';
import { enhanceOptions } from 'labstep-web/services/utils.service';
import type React from 'react';
import type { IProtocolTimerActionEditProps } from './types';

export const ProtocolTimerActionEdit: React.FC<
  IProtocolTimerActionEditProps
> = ({ protocolTimer, viewComponent, options }) => {
  const canEdit = useHasAccess(
    protocolTimer.entityName,
    protocolTimer.guid,
    Action.edit,
    ['name', 'hours', 'minutes', 'seconds'],
  );

  return (
    <Modal
      header={`Edit ${ProtocolTimer.getHumanReadableEntityName(
        false,
        true,
      )}`}
      viewComponent={({ toggleModal }) => {
        const onClick = canEdit ? toggleModal : undefined;
        if (viewComponent) {
          return viewComponent({ toggleModal: onClick });
        }
        if (!canEdit) {
          return null;
        }
        return (
          <EntityActionEdit
            entity={protocolTimer}
            actionComponentProps={{
              type: 'option',
              disabled: !canEdit,
              text: 'Edit',
              icon: 'pencil',
              onClick,
            }}
          />
        );
      }}
      content={({ toggleModal }) => (
        <EditTimerForm
          protocolTimer={protocolTimer}
          options={enhanceOptions({
            options,
            onSuccess: toggleModal,
          })}
        />
      )}
    />
  );
};
